import React, { useState } from "react";
import { Button, ButtonSize, ButtonVariant, MITheme } from "@spectrumselect/mi-ui-react";
import { FormResolveType } from "../../redux/AppStateSlice";
import { local } from "../../internationalization/Localization";
import { S } from "../../auth/sdk"
import "./RememberDeviceForm.scss"

interface RememberDeviceFormProps {
  resolve?: FormResolveType;
  tenant: string;
}

export const RememberDeviceForm: React.FunctionComponent<RememberDeviceFormProps> = (props) => {
  const [remember, setRemember] = useState(false)
  const rememberOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve && props.resolve(S.FormInput.createFormInputSubmissionRequest({ remember_me: remember }));
  };
  const handleRemember = (e) => {
    setRemember(e.target.value === "yes")
  }
  return (
    <form className="RememberDeviceForm">
      <h1 className="App_pageTitle">Should we trust this device?</h1>
      <div className="App_formButtonGroup">
        <div onChange={(e) => handleRemember(e)}>
          <div className="remember-section">
            <input className="remember-input" type="radio" value="yes" name="remember" />
            <span className="remember-device">
              <span className="remember-label remember-main"> {local.get("rememberDeviceForm.buttonLabels[1]")}
              </span><br />
              <p className="lower-section">
                <p>For your convenience, we will remember this device for <span className="remember-label">30 days</span><br />
                  before requiring additional email verification</p>
              </p>
            </span>

          </div>
          <div className="remember-section">
            <input className="remember-input" type="radio" value="no" name="remember" />
            <span className="remember-device">
              <span className="remember-label remember-main"> {local.get("rememberDeviceForm.buttonLabels[0]")}
              </span><br />
              <p className="lower-section">
                We will <span className="remember-label">continue to require additional email verification</span> <br />
                whenever anyone tries to log in from this device
              </p>
            </span>
          </div>
        </div>
      </div>
      <div className="App_formButtonGroup">
        <Button
          className={`login100-form-btn ${props.tenant}-btn`}
          variant={ButtonVariant.primary}
          type="submit"
          onClick={rememberOnClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
         Continue to Log in
        </Button>
      </div>
    </form>
  )
}
